import { render } from "./channel.vue?vue&type=template&id=5f5b24ba&lang=pug"
import script from "./channel.vue?vue&type=script&setup=true&lang=js"
export * from "./channel.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__